import React, { useState, useEffect } from 'react';
import './style.css';
import Logo from '../../assets/LOGOTIPO.png';
import User from '../../assets/User.png';
import { NavLink } from "react-router-dom";
import { useAppContext } from '../../context/AppContext';

const Sidebar = () => {
    const [activeMenu, setActiveMenu] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
    const { companies, selectedCompany, setSelectedCompany, licenca} = useAppContext();

    const toggleMenu = (menu) => {
        setActiveMenu(activeMenu === menu ? null : menu);
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleCompanyChange = (event) => {
        setSelectedCompany(event.target.value); // Armazena "null" para todas as empresas
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setSidebarOpen(false);
            } else {
                setSidebarOpen(true);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div >
            <div className="hamburger" onClick={toggleSidebar}>
                <i className="fa-solid fa-bars"></i> {/* Ícone de hambúrguer */}
            </div>
            <div className={`d-flex flex-column justify-content-between menu-container sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
                <div>
                    <div className="logo-details">
                        <img className="Logo" src={Logo} alt="logo" />
                        <span className="logo-name">Fabrica</span>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu0')}>
                        <NavLink to="/principal" className="dropdown-item">
                            Dashboard
                        </NavLink>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu1')}>
                        <div className='menu-item-texto'>Cadastros
                            <i className={`bx ${activeMenu === 'menu1' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}`}></i>
                        </div>

                        <div className={`submenu ${activeMenu === 'menu1' ? 'active' : ''}`}>
                            <div className="submenu-item" onClick={() => toggleMenu('menu11')}>
                                <NavLink to="/cad/empresa" className="dropdown-item">
                                    Empresa
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu12')}>
                                <NavLink to="/cad/usuario" className="dropdown-item">
                                    Usuário
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu13')}>
                                <NavLink to="/cad/produto" className="dropdown-item">
                                    Produto
                                </NavLink>
                            </div>                            
                        </div>                        
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu2')}>
                        <div className='menu-item-texto'>Operações
                            <i className={`bx ${activeMenu === 'menu2' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}`}></i>
                        </div>

                        <div className={`submenu ${activeMenu === 'menu2' ? 'active' : ''}`}>
                            <div className="submenu-item">
                                <NavLink to="/ope/pedido" className="dropdown-item">
                                    Pedido
                                </NavLink>
                            </div>                                                                                     
                        </div>                        
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu3')}>
                        <div className='menu-item-texto'>Relatórios
                            <i className={`bx ${activeMenu === 'menu3' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}`}></i>
                        </div>

                        <div className={`submenu ${activeMenu === 'menu3' ? 'active' : ''}`}>
                            <div className="submenu-item">
                                <NavLink to="/rel/pedido" className="dropdown-item">
                                    Pedido
                                </NavLink>
                            </div>                       

                            <div className="submenu-item">
                                <NavLink to="/rel/producaofuncionario" className="dropdown-item">
                                    Produção por func.
                                </NavLink>
                            </div>                                               
                        </div>                        
                    </div>                    
                </div>

                {/* Adicione mais menus conforme necessário */}

                <div className="profile-details">
                    <div className="profile-content">
                        <img src={User} alt="User" />
                    </div>
                    <div className="name-job">                        
                        <div className="profile-name">
                            {/* Contêiner para o select */}
                            <div className="select-container">
                                <select className="form-select sidebar-select" value={selectedCompany || '0'} onChange={handleCompanyChange}>
                                    <option value="0">Todas as empresas</option>
                                    {companies.map((company, index) => (
                                        <option key={index} value={company.codempresa}>{company.razaosocial}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="job mt-1">
                            {licenca ? <label className='bg-success'>Licenciado</label> : <label className='bg-danger'>Expirado...</label>}
                        </div>
                        <div className="job">0.0.1.1</div>
                    </div>

                    <i className="bx bx-log-out"></i>
                </div>
            </div>

        </div>
    );
};

export default Sidebar;
